import {Component, Input, OnInit} from '@angular/core'
import {MatIcon} from '@angular/material/icon'
import {MatProgressBar} from '@angular/material/progress-bar'
import {MatDialog} from '@angular/material/dialog'
import {MatPaginator, PageEvent} from '@angular/material/paginator'
import {AuthService} from '../../../core/services/auth/auth.service'
import {EmployeeService} from '../../../core/services/employee/employee/employee.service'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {TableListOSComponent} from '../../../shared/components/table-list-os/table-list-os.component'
import {MatButton, MatIconButton} from '@angular/material/button'
import {MatFormField, MatLabel} from '@angular/material/input'
import {MatOption, MatSelect} from '@angular/material/select'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {SnackbarCustomService} from '../../../shared/components/snackbar/snackbar-custom.service'
import {LogisticsContractItemViewComponent} from '../logistics-contract-item-view/logistics-contract-item-view.component'
import {ContractItemService} from '../../../core/services/contract/contract-item/contract-item.service'
import {
  LogisticsContractItemCreateComponent
} from '../logistics-contract-item-create/logistics-contract-item-create.component'
import {
  LogisticsContractItemEditComponent
} from '../logistics-contract-item-edit/logistics-contract-item-edit.component'
import {
  ModalGroupingSuggestionComponent
} from '../modal-grouping-suggestion/modal-grouping-suggestion.component'
import {StretchTypeService} from '../../../core/services/stretch/stretch-type/stretch-type.service'
import {DriverTypeService} from '../../../core/services/driver/driver-type/driver-type.service'
import {VehicleTypeService} from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import {FormsModule} from '@angular/forms'
import {MatInput} from '@angular/material/input'
import { MatTooltip } from '@angular/material/tooltip'
import { LogisticsValidationModalComponent } from '../logistics-validation-modal/logistics-validation-modal.component'
import { GroupingSuggestionService } from '../../../core/services/grouping-suggestion/grouping-suggestion.service'
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component'
import { ContractCoordinatorService } from '../../../core/services/contract-coordinator/contract-coordinator.service'
import { ModalCoordinatorsComponent } from '../modal-coordinators/modal-coordinators.component'
import { StatusContratoItemService } from '../../../core/services/contract/status-contrato-item/status-contrato-item.service'
import { PassageiroItemContratoService } from '../../../core/services/passageiro-item-contrato/passageiro-item-contrato.service'

@Component({
  selector: 'logistics-item-logistic',
  imports: [
    MatProgressBar,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    TableListOSComponent,
    MatPaginator,
    MatIcon,
    MatButton,
    MatIconButton,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
    MatInput,
    FormsModule,
    MatTooltip,
    MatProgressSpinner,
  ],
  templateUrl: './logistics-item-logistic.component.html',
  styleUrl: './logistics-item-logistic.component.scss',
  standalone: true,
  providers: [EmployeeService],
})
export class LogisticsItemLogisticComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private contractItemService: ContractItemService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private stretchTypeService: StretchTypeService,
    private driverTypeService: DriverTypeService,
    private vehicleTypeService: VehicleTypeService,
    private sugestaoService: GroupingSuggestionService,
    private contratoCoordenadorService: ContractCoordinatorService,
    private statusContratoItemService: StatusContratoItemService,
    private passageiroItemContratoService: PassageiroItemContratoService,
  ) {}

  @Input() data: any
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: any = { search: false, model: {} }
  orderBySelected: string = ''
  stretchTypes: any[] = []
  driverTypes: any[] = []
  vehicleTypes: any[] = []
  statusContratoItens: any[] = []
  selectedItems: any[] = []
  deletingBatch = false
  excluindoTudo = false
  necessitaCoordenador = false
  itemSearchForm = {
    itemPropostaId: null as number | null,
    origemCidade: '',
    origemEstado: '',
    destinoCidade: '',
    destinoEstado: '',
    tipoMotoristaId: null as number | null,
    tipoVeiculoId: null as number | null,
    tipoTrechoId: null as number | null,
    pax: null as number | null,
    dataInicio: '',
    dataFinal: '',
    nomePassageiro: '',
    statusId: null as number | null,
  }
  sorts: any[] = [
    { id: 'pax:asc', description: 'Pax' },
    { id: 'servico:asc', description: 'Serviço' },
    { id: 'origemDestinoLogistica:asc', description: 'Trecho' },
    { id: 'valor:asc', description: 'Valor' },
    { id: 'valorExtra:asc', description: 'Valor Extra' },
    { id: 'veiculo:asc', description: 'Veículo' },
  ]

  sortChange(event: any) {
    this.orderBySelected = event.value
    this.page = 1
    this.uploadList()
  }

  columns: any[] = [
    { keyColumn: 'logistica_trecho', key: '_trecho', description: 'Trecho' },
    { keyColumn: 'os_service', key: 'os_service', description: 'Serviço' },
    { keyColumn: 'os_vehicle', key: 'os_vehicle', description: 'Veículo' },
    { keyColumn: 'data_emergencial', key: 'dataInicio', description: 'Data' },
    { keyColumn: 'pax', key: 'quantidadePassageiro', description: 'PAX' },
    { keyColumn: 'hora', key: 'horaInicio', description: 'Hora' },
    { keyColumn: 'logistica_valor', key: '_valor', description: 'Valor' },
    { keyColumn: 'statusDescricao', key: 'statusDescricao', description: 'Status Logística' },
    { keyColumn: 'action', key: { view: false, itinerary: false, addPassenger: false, delete: true }, description: 'Ações' },
  ]

  screen = 'contrato item'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
    this.loadSelectData()
    this.checkCoordenadores()
  }

  loadSelectData() {
    this.stretchTypeService.listStretchType().subscribe({
      next: (res: any) => {
        this.stretchTypes = res.data || []
      },
      error: () => {},
    })
    this.driverTypeService.listDriverType().subscribe({
      next: (res: any) => {
        this.driverTypes = res.data || []
      },
      error: () => {},
    })
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (res: any) => {
        this.vehicleTypes = res.data || []
      },
      error: () => {},
    })
    this.statusContratoItemService.listStatusContratoItem().subscribe({
      next: (res: any) => {
        this.statusContratoItens = res.data || []
      },
      error: () => {},
    })
  }

  performSearch() {
    this.searchForm = {
      search: true,
      model: this.buildSearchPayload(this.itemSearchForm),
    }
    this.page = 1
    this.uploadList()
  }

  clearSearch() {
    this.itemSearchForm = {
      itemPropostaId: null,
      origemCidade: '',
      origemEstado: '',
      destinoCidade: '',
      destinoEstado: '',
      tipoMotoristaId: null,
      tipoVeiculoId: null,
      tipoTrechoId: null,
      pax: null,
      dataInicio: '',
      dataFinal: '',
      nomePassageiro: '',
      statusId: null,
    }
    this.searchForm = { search: false, model: {} }
    this.page = 1
    this.uploadList()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => ele.keyColumn == 'action')
    if (index != -1) {
      this.columns[index].key = {
        view: true,
        edit: true,
        itinerary: this.checkPermission('editar'),
        addPassenger: this.checkPermission('editar'),
        removerAssociacoes: this.checkPermission('editar'),
        deletarItem: true,
        delete: this.checkPermission('deletar'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  getSearchItems(model: any) {
    this.loading = true
    this.contractItemService.searchPagedContractItem(this.page, this.rows, model, this.orderBySelected).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
        this.loading = false
      },
      error: () => {
        this.snackbar.error('Não foi possível listar os itens de logística.')
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  buildSearchPayload(form: any) {
    return {
      itemPropostaId: form.itemPropostaId || 0,
      origemId: 0,
      descricaoOrigem: '',
      origemCidade: form.origemCidade || '',
      origemEstado: form.origemEstado || '',
      destinoId: 0,
      descricaoDestino: '',
      destinoCidade: form.destinoCidade || '',
      destinoEstado: form.destinoEstado || '',
      tipoServicoId: 0,
      descricaoTipoServico: '',
      servicoId: 0,
      descricaoServico: '',
      propostaId: this.data.propostaId || 0,
      tipoMotoristaId: form.tipoMotoristaId || 0,
      tipoVeiculoId: form.tipoVeiculoId || 0,
      contratoId: this.data.id,
      pax: form.pax || 0,
      dataInicio: form.dataInicio || '',
      dataFinal: form.dataFinal || '',
      tipoTrechoId: form.tipoTrechoId || 0,
      nomePassageiro: form.nomePassageiro || '',
      statusId: form.statusId || 0,
    }
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search) {
      this.getSearchItems(this.searchForm.model)
    } else {
      this.getListItems()
    }
  }

  private defaultPayload() {
    return {
      itemPropostaId: 0,
      origemId: 0,
      descricaoOrigem: '',
      origemCidade: '',
      origemEstado: '',
      destinoId: 0,
      descricaoDestino: '',
      destinoCidade: '',
      destinoEstado: '',
      tipoServicoId: 0,
      descricaoTipoServico: '',
      servicoId: 0,
      descricaoServico: '',
      propostaId: this.data.propostaId || 0,
      tipoMotoristaId: 0,
      tipoVeiculoId: 0,
      contratoId: this.data.id,
      pax: 0,
      dataInicio: '',
      dataFinal: '',
      tipoTrechoId: 0,
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        const paisO = item.paisOrigem ? ` (${item.paisOrigem})` : ''
        const paisD = item.paisDestino ? ` (${item.paisDestino})` : ''
        list.push({
          ...item,
          tipoServico: item.tipoServicoDescricao || '-',
          servico: item.serfvicoDescricao || item.servicoDescricao || '-',
          nomeTipoVeiculo: item.tipoVeiculoDescricao || '-',
          nomeTipoMotorista: item.tipoMotoristaDescricao || '-',
          _trecho: `Origem\nCidade: ${item.cidadeOrigem || '-'}\nEstado: ${item.estadoOrigem || '-'}${paisO}\nDestino\nCidade: ${item.cidadeDestino || '-'}\nEstado: ${item.estadoDestino || '-'}${paisD}`,
          _horarios: `Início: ${item.horaInicio?.substring(0, 5) || '-'}\nFim: ${item.horaFinal?.substring(0, 5) || '-'}`,
          _valor: `Valor: R$ ${this.formatCurrency(item.valorProposta)}\nC. Taxa: R$ ${this.formatCurrency(item.valorComTaxa)}`,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  private formatCurrency(value: any): string {
    if (value == null) return '-'
    const n = typeof value === 'number' ? value : parseFloat(value)
    if (isNaN(n)) return '-'
    return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  getListItems() {
    this.loading = true
    this.contractItemService
      .searchPagedContractItem(this.page, this.rows, this.defaultPayload(), this.orderBySelected)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: () => {
          this.snackbar.error('Não foi possível listar os itens de logística.')
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  viewContratoItem(item: any) {
    const dialogRef = this.dialog.open(LogisticsContractItemViewComponent, {
      data: { id: item.id },
      maxWidth: '95vw',
      maxHeight: '95vh',
    })
    dialogRef.afterClosed().subscribe(() => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Excluir item de logística',
        message: 'Deseja realmente excluir este item? Essa ação não pode ser desfeita.',
        confirmLabel: 'Excluir',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      this.loading = true
      this.contractItemService.deleteContractItem({ id: item.id, descricao: '' }).subscribe({
        next: () => {
          this.snackbar.success('Item de logística excluído com sucesso!')
          this.uploadList()
        },
        error: (err) => {
          console.error(err)
          this.snackbar.error('Não foi possível excluir o item de logística.')
          this.loading = false
        },
      })
    })
  }

  deletarItemGrupo(item: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Deletar item de contrato',
        message: 'Deseja realmente deletar este item de contrato? Todos os passageiros serão desvinculados e o item será removido. Essa ação não pode ser desfeita.',
        confirmLabel: 'Deletar',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      this.loading = true
      this.sugestaoService.deletarItem(item.id).subscribe({
        next: (res: any) => {
          this.snackbar.success(res?.message || 'Item de contrato deletado com sucesso!')
          this.uploadList()
        },
        error: () => {
          this.snackbar.error('Não foi possível deletar o item de contrato.')
          this.loading = false
        },
      })
    })
  }

  onSelectionChange(selected: any[]) {
    this.selectedItems = selected
  }

  deleteBatch() {
    const count = this.selectedItems.length
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Excluir itens em lote',
        message: `Deseja excluir ${count} item${count > 1 ? 'ns' : ''} selecionado${count > 1 ? 's' : ''}? Todos os passageiros serão desvinculados e os itens removidos. Essa ação não pode ser desfeita.`,
        confirmLabel: 'Excluir',
      },
    })

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      this.deletingBatch = true
      const ids = this.selectedItems.map((item) => item.id)
      this.sugestaoService.deletarItens(ids).subscribe({
        next: (res: any) => {
          this.snackbar.success(res?.message || 'Itens excluídos com sucesso!')
          this.selectedItems = []
          this.uploadList()
        },
        error: (err) => {
          this.snackbar.errorRequest(err)
          this.deletingBatch = false
        },
        complete: () => {
          this.deletingBatch = false
        },
      })
    })
  }

  excluirTudo() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '420px',
      data: {
        title: 'Excluir tudo',
        message: 'Deseja realmente excluir TODOS os itens deste contrato? Isso remove em cascata OS, passageiros e agendas vinculadas. Essa ação não pode ser desfeita.',
        confirmLabel: 'Excluir tudo',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      this.excluindoTudo = true
      this.passageiroItemContratoService.deleteTodos(this.data.id).subscribe({
        next: (res: any) => {
          this.snackbar.success(res?.message || 'Todos os itens do contrato foram excluídos com sucesso!')
          this.selectedItems = []
          this.uploadList()
        },
        error: (err) => {
          this.snackbar.errorRequest(err)
          this.excluindoTudo = false
        },
        complete: () => {
          this.excluindoTudo = false
        },
      })
    })
  }

  removerAssociacoesGrupo(item: any) {
    if (confirm('Deseja desvincular todos os passageiros deste grupo?')) {
      this.loading = true
      this.sugestaoService.removerAssociacoesItem(item.id).subscribe({
        next: (res: any) => {
          this.snackbar.success(res?.message || 'Passageiros desvinculados com sucesso!')
          this.uploadList()
        },
        error: () => {
          this.snackbar.error('Não foi possível desvincular os passageiros.')
          this.loading = false
        },
      })
    }
  }

  openItinerary(item: any) {
    // TODO: abrir modal de itinerário do item
    console.log('itinerário do item:', item)
  }

  openPassengers(item: any) {
    // TODO: abrir modal de passageiros do item
    console.log('passageiros do item:', item)
  }

  openValidacao() {
    const dialogRef = this.dialog.open(LogisticsValidationModalComponent, {
      data: { id: this.data.id },
      width: '90vw',
      maxWidth: '1100px',
      maxHeight: '90vh',
    })
    dialogRef.afterClosed().subscribe(() => {
      this.uploadList()
      this.checkCoordenadores()
    })
  }

  openSugestaoAgrupamento() {
    const dialogRef = this.dialog.open(ModalGroupingSuggestionComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: this.data,
    })
    dialogRef.afterClosed().subscribe(() => {
      this.uploadList()
      this.checkCoordenadores()
    })
  }

  editContratoItem(item: any) {
    const dialogRef = this.dialog.open(LogisticsContractItemEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '900px',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { id: item.id },
    })
    dialogRef.componentInstance.response.subscribe((success: boolean) => {
      if (success) {
        this.uploadList()
      }
    })
    dialogRef.afterClosed().subscribe(() => {
      this.uploadList()
      this.checkCoordenadores()
    })
  }

  addItem() {
    const dialogRef = this.dialog.open(LogisticsContractItemCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: this.data,
    })

    dialogRef.componentInstance.response.subscribe((success: boolean) => {
      if (success) {
        this.uploadList()
      }
    })
    dialogRef.afterClosed().subscribe(() => {
      this.uploadList()
      this.checkCoordenadores()
    })
  }

  checkCoordenadores() {
    this.contratoCoordenadorService.getNecessidade(this.data.id).subscribe({
      next: (r: any) => {
        this.necessitaCoordenador = r.data?.necessitaCoordenador ?? false
      },
      error: () => {},
    })
  }

  openCoordenacao() {
    const dialogRef = this.dialog.open(ModalCoordinatorsComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '700px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { contratoId: this.data.id },
    })
    dialogRef.afterClosed().subscribe(() => {
      this.uploadList()
      this.checkCoordenadores()
    })
  }

}
